import { Component, Input, OnInit } from '@angular/core';
import { SetIntestazione } from 'src/app/shared/models/node';

@Component({
  selector: 'app-text-header',
  templateUrl: './text-header.component.html',
  styleUrls: ['./text-header.component.scss']
})
export class TextHeaderComponent implements OnInit {

  @Input() block: SetIntestazione = {} as SetIntestazione;

  constructor() { }

  ngOnInit(): void {
  }

}
